export const updateURLQuery = (formState) => {
    try {
        const params = new URLSearchParams();
        Object.entries(formState).forEach(([key, value]) => {
            if (value) {
                params.append(key, value);
            }
        });
        const url = new URL(window.location);
        url.search = params.toString();
        window.history.replaceState(null, '', url);
    } catch (error) {
        // console.error('Error updating URL query:', error);
    }
};